import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { APPLICATION_LINK, LINKS } from '@/Module/Core/Constant';
const SubscriptionHistoryNoPrevious: FC = () => {
  const router = useRouter();
  const onClickHandler = () => {
    router.push(`${APPLICATION_LINK}${LINKS.SUBSCRIPTION.MAIN}`);
  };
  return <div className="border-4 border-blueFive bg-blueOne p-6" data-sentry-component="SubscriptionHistoryNoPrevious" data-sentry-source-file="SubscriptionHistoryNoPrevious.tsx">
      <div className="text-xl font-bold text-blueFive">
        آی‌نویی عزیز، شما اشتراک فعالی ندارید، برای خرید اشتراک روی دکمه زیر کلیک کن
      </div>
      <div className="my-6 flex justify-center lg:my-8">
        <Button onClick={onClickHandler} className=" w-full md:w-auto" variant="shadow" color="primary" radius="circle" size="large" bold data-sentry-element="Button" data-sentry-source-file="SubscriptionHistoryNoPrevious.tsx">
          خرید اشتراک
        </Button>
      </div>
    </div>;
};
export default SubscriptionHistoryNoPrevious;